import React from 'react';
import './ModalDre.css';  

const ModalDreContasPendentes = ({ isOpen, onClose, contasPendentes }) => {
    if (!isOpen) return null;

    const formatDateISOtoDMY = (isoDate) => {
        const date = new Date(isoDate); 
        
        if (isNaN(date)) return ''; 
        
        const day = date.getDate().toString().padStart(2, '0'); 
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear(); 
        
        return `${day}/${month}/${year}`; 
      };       

    return (
        <div id="modal-overlay" onClick={onClose}>
            <div id="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Informações de Contas Pendentes</h2>
                <table>
                    <thead>
                        <tr>
                            <th>SEQ</th>
                            <th>Data Vencimento</th>
                            <th>Valor</th>
                            <th>Juros</th>
                            <th>Multa</th>
                            <th>Desconto</th>
                            <th>Valor Pago</th>
                            <th>Saldo</th>                           
                        </tr>
                    </thead>
                    <tbody>
                        {contasPendentes.map((item, index) => (
                            <tr key={index}>
                                <td>{item.SEQ}</td>
                                <td>{new Date(item.DATA_VENC).toLocaleDateString()}</td>
                                <td>{Number(item.VALOR).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.JUROS).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.MULTA).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.DESCONTO).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.VALOR_PAGO).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.SALDO).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button id="close-btn" className='mt-3' onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
};

export default ModalDreContasPendentes;
